import type {
	PublicCloudinaryUrl,
	RentalTemplateContextConfig
} from "@fergmar/contracts/public/rental-sites";
import { parkwoodSiteConfig } from "@fergmar/contracts/public/sites/parkwood-site-config";
import { villasSiteConfig } from "@fergmar/contracts/public/sites/villas-site-config";
import { domainRouting, getDomainKey, type DisplaySite } from "./domain-routing.js";

export function createDomainRegistry(cloudinaryUrl: PublicCloudinaryUrl) {
	const siteConfigByKey: Partial<Record<DisplaySite, RentalTemplateContextConfig>> = {
		"thevillastx.com": villasSiteConfig(cloudinaryUrl),
		"liveatparkwood.com": parkwoodSiteConfig(cloudinaryUrl)
	};

	function getDomainEntry(hostname: string) {
		const key = getDomainKey(hostname);
		if (!key) return null;
		return { ...domainRouting[key], siteConfig: siteConfigByKey[key] ?? null };
	}

	return { getDomainEntry };
}
